exports._unsafeEvalExpr = function (expr) {
  // eslint-disable-next-line
  var result = eval(expr);
  if (result.toString) {
    return result.toString();
  } else {
    return result;
  }
};
